import { getXPartner } from "@/app/utils/helper";
import moment from "moment";

interface Headers {
    [key: string]: string;
}

const requestHeaders: Headers = {
    "X-partner": getXPartner(),
};

const requestOptions: RequestInit = {
    headers: requestHeaders,
};

export const getUEListDataISIN = async () => {
    try {
        const response = await fetch(`${process.env.API_STOCKS_URL}/unlisted/equities/isins`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
};

export const getStockUnitsPrice = async (ISIN: string, units: number) => {
    const date = moment().format("MM/DD/YYYY");
    try {
        const response = await fetch(
            `${process.env.API_STOCKS_URL}/unlisted/equities/isins/${ISIN}/prices?tradeDate=${date}&units=${units}`,
        );
        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching stock unit price:", err);
        return null;
    }
};

export const getUnlistedPriceData = async (ISIN: string) => {
    try {
        const response = await fetch(
            `${process.env.API_STOCKS_URL}/unlisted/equities/isins/${ISIN}/prices/all`,
            requestOptions,
        );
        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching stock unit price:", err);
        return null;
    }
};

export const getUnitPriceUnlisted = async (ISIN: string, units: number) => {
    const date = moment().format("MM/DD/YYYY");
    try {
        const response = await fetch(
            `${process.env.API_STOCKS_URL}/unlisted/equities/isins/${ISIN}/prices?tradeDate=${date}&units=${units}`,
            requestOptions,
        );
        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching stock unit price:", err);
        return null;
    }
};

export const getPriceDiff = async (ISIN: string, days: number) => {
    try {
        const response = await fetch(
            `${process.env.API_STOCKS_URL}/unlisted/equities/isins/${ISIN}/prices/difference?days=${days}`,
            requestOptions,
        );
        const data = await response.json();
        return data;
    } catch (err) {
        console.error("Error fetching stock unit price:", err);
        return null;
    }
};

export const getProductSpecificFaqData = async (productType?: string, product?: string) => {
    try {
        const response = await fetch(
            `${process.env.API_STOCKS_URL}/faqs/${product}?productType=${productType}`,
            requestOptions,
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
};

export const getProductByISIN = async (isin: string) => {
    try {
        const response = await fetch(
            `${process.env.API_STOCKS_URL}/unlisted/equities/isins/${isin}`,
            { ...requestOptions, credentials: "include" },
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching product data:", err);
        return err;
    }
};

export const getPendingTransactions = async () => {
    try {
        const response = await fetch(
            `${process.env.API_STOCKS_URL}/unlisted/equities/portfolio/transactions?pendingTxns=true`,
            { ...requestOptions, credentials: "include" },
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching pending transactions:", err);
        return err;
    }
};

export const cancelUnlistedTransaction = async () => {
    try {
        const response = await fetch(
            `${process.env.API_STOCKS_URL}/unlisted/equities/portfolio/transactions/cancelAll`,
            {
                method: "POST",
                headers: {
                    ...requestHeaders,
                    "Content-Type": "application/json",
                },
                credentials: "include",
            },
        );

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error cancelling transactions:", err);
        return err;
    }
};
